import i18next from 'i18next';
import { namespacesType } from '../i18n/i18nConfigs';

interface PropTypes {
  key: string;
  ns?: namespacesType;
  label?: string | number;
}

export const translate = ({ key, ns = 'common', label }: PropTypes) => {
  return i18next.t(key, { ns, label });
};
